// import Vue from 'vue';

import {
  formatRelative, add, format, parseISO,
  formatDistanceToNow,
} from 'date-fns';
import { ru } from 'date-fns/locale';

const LOCALE = { locale: ru };
const DEFAULT_FORMAT = 'yyyy-MM-dd HH:mm';

const formatRelativeLocale = {
  lastWeek: 'dd MMMM - cccc',
  yesterday: "'Вчера'",
  today: "'Сегодня'",
  tomorrow: "'Завтра'",
  nextWeek: "'На следующей неделе' - eeee",
  other: 'dd.MM.yyyy',
};

const RELATIVE_LOCALE = {
  ...ru,
  formatRelative: (token) => formatRelativeLocale[token],
};

export const dateprintFormat = (
  value,
  formatstring = DEFAULT_FORMAT,
) => value && format(parseISO(value), formatstring, LOCALE);
// Перевести вывести ISO дату в человекочистаемом формате
export const dateprintString = (value) => value && dateprintFormat(value, 'd MMMM в HH:mm');
// Перевести время с сервера для фронта
export const dateprintDefault = (value) => value && dateprintFormat(value, 'yyyy-MM-dd HH:mm');
// Добавить минуты
export const dateprintAdd = (value, duration) => add(parseISO(value), { minutes: duration });
// Перевести время с фронта для сервера
export const dateprintServer = (value) => value && value.toISOString();

export const dateprintRelative = (date, dateFrom) => formatRelative(
  parseISO(date), dateFrom, { locale: RELATIVE_LOCALE },
);
export const dateprintFormatDistanceToNow = (
  value,
) => formatDistanceToNow(parseISO(value), { locale: ru });

export default {
  dateprintString,
  dateprintDefault,
  dateprintAdd,
  dateprintServer,
  dateprintFormat,
  dateprintRelative,
  formatDistanceToNow,
};
